import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Button } from '../../shared/button/Button';
import { Scrollable } from '../../shared/scrollable/Scrollable';
import styles from './DocumentName.module.scss';
import { DocumentNamePageView, fetchAgreementTypeHierarchyStarted, getCurrentAgreementTypes, setAgreementRelationshipId, setDocumentNamePageView } from './store';

export const AgreementTypeRelationshipSelect: React.FC = () => {
    const dispatch = useAppDispatch();
    const agreementTypes = useAppSelector(getCurrentAgreementTypes);

    const setAgreementType = useCallback((agreementTypeId: number | null) => {
        dispatch(setAgreementRelationshipId(agreementTypeId));
        dispatch(fetchAgreementTypeHierarchyStarted(agreementTypeId));
    }, [dispatch]);

    const backToDocumentNamesTable = useCallback(() => dispatch(setDocumentNamePageView(DocumentNamePageView.TABLE)), [dispatch]);
    const toFamilyTree = useCallback(() => dispatch(setDocumentNamePageView(DocumentNamePageView.FAMILY_TREE)), [dispatch]);

    return (
        <div className={styles.agreementFamilyTreeSelectWrapper} data-testid='agreement-types-modal-wrapper'>
            <div className={styles.titleWrapper}>
                <div className={styles.title}>Agreement Types</div>
                <Button width='fit-content' label='See All Relationships' onClick={toFamilyTree} />
            </div>
            <div className={styles.agreementTypesScrollableWrapper}>
                <Scrollable>
                    <div className={styles.agreementTypeOptions}>
                        {agreementTypes.map(({ agreementTypeId, name }, index) => (
                            <div className={styles.agreementType} key={index} id={`agreement-type-${index}`} onClick={() => setAgreementType(agreementTypeId)}>
                                {name}
                            </div>
                        ))}
                    </div>
                </Scrollable>
            </div>
            <div className={styles.buttonWrapper}>
                <Button label='Back' onClick={backToDocumentNamesTable} />
            </div>
        </div>
    );
};
